export default __webpack_public_path__ + "049bdb3ffe9c199aee4a3bb9ea8cbe1a.png";